import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useGameStore = defineStore('game', () => {
  const games = ref([])
  const currentCategory = ref('all')
  const currentPage = ref(1)
  const PAGE_SIZE = 12

  // Get hot games
  const hotGames = computed(() => {
    return [...games.value].sort((a, b) => b.plays - a.plays).slice(0, 5)
  })

  // Get games by current category
  const categoryGames = computed(() => {
    if (currentCategory.value === 'all') return games.value
    return games.value.filter(game => game.category === currentCategory.value)
  })

  // Get paginated games
  const visibleGames = computed(() => {
    return categoryGames.value.slice(0, currentPage.value * PAGE_SIZE)
  })

  // Load game data
  const loadGames = async () => {
    try {
      const response = await fetch('/games.json')
      const data = await response.json()
      games.value = data.games
      return data.games
    } catch (error) {
      console.error('Failed to load game data:', error)
      return []
    }
  }

  // Get game by ID
  const getGameById = (id) => {
    return games.value.find(game => game.id === id)
  }

  // Update game data
  const updateGame = (gameId, updates) => {
    const gameIndex = games.value.findIndex(g => g.id === gameId)
    if (gameIndex !== -1) {
      games.value[gameIndex] = { ...games.value[gameIndex], ...updates }
    }
  }

  return {
    games,
    currentCategory,
    currentPage,
    hotGames,
    categoryGames,
    visibleGames,
    loadGames,
    getGameById,
    updateGame
  }
}) 